"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollaborationContentType = void 0;
var CollaborationContentType;
(function (CollaborationContentType) {
    CollaborationContentType[CollaborationContentType["Folder"] = 1] = "Folder";
    CollaborationContentType[CollaborationContentType["RootFolder"] = 2] = "RootFolder";
    CollaborationContentType[CollaborationContentType["ShareFolderShortcut"] = 3] = "ShareFolderShortcut";
    CollaborationContentType[CollaborationContentType["DocumentCartFolder"] = 4] = "DocumentCartFolder";
    CollaborationContentType[CollaborationContentType["RequestHistoryFolder"] = 5] = "RequestHistoryFolder";
    CollaborationContentType[CollaborationContentType["LiveShareAdhocFolder"] = 6] = "LiveShareAdhocFolder";
    CollaborationContentType[CollaborationContentType["LiveSendAdhocFolder"] = 7] = "LiveSendAdhocFolder";
    CollaborationContentType[CollaborationContentType["Content"] = 10] = "Content";
    CollaborationContentType[CollaborationContentType["ShareContentShortcut"] = 11] = "ShareContentShortcut";
    CollaborationContentType[CollaborationContentType["ContentShortcut"] = 12] = "ContentShortcut";
})(CollaborationContentType = exports.CollaborationContentType || (exports.CollaborationContentType = {}));
//# sourceMappingURL=CollaborationContentType.js.map